
export function transformTask (task) {
  if (task) {
    if (typeof task.result === 'string' && task.result.startsWith('{')) {
      task.result = JSON.parse(task.result)
    }
    if (typeof task.data === 'string' && task.data.startsWith('{')) {
      task.data = JSON.parse(task.data)
    } else {
      task.data = {}
    }
  }
  return task
}



// WEBPACK FOOTER //
// ./src/utils/tasks.js